import { UserUtil } from "../../../../core/user-util"

export class ParamApiAlerta {
	static DEV_MODE = true;
	// configuracao anterior
	// static getUrl(){
	// 	return this.DEV_MODE ? 'http://localhost:8090' : UserUtil.parametrosList['API_ALERTA_URL']
	// }

  // configuracao dev
  static getUrl(){
    return this.DEV_MODE ? 'http://localhost:8081' : UserUtil.parametrosList['API_ALERTA_URL']
  }

	static getAuth(){
		if (this.DEV_MODE) {
			return {
				"username": 'admin@csiway.com.br',
				"password": '1234'
			}
		}else{
			return {
				username: UserUtil.parametrosList['API_ALERTA_USERNAME'],
				password: UserUtil.parametrosList['API_ALERTA_PASSWORD']
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/modulos/portal/telas/alerta-monitoramento/paramApiAlerta.ts